<div class="auth-page-layout flex bg-surface-0 dark:bg-surface-900 h-full">
  <div class="w-full mx-auto lg:px-12 h-full">
    <div class="w-full mx-auto lg:px-12 h-full">
      <div class="w-full mx-auto lg:px-12 h-full">
        <div class="grid grid-cols-12 gap-4 h-full items-center">
          <div class="col-span-12 md:col-span-7 p-6 bg-surface-0 dark:bg-surface-900 rounded-l">
            <ng-content></ng-content>
          </div>

          <div class="col-span-12 md:col-span-5 p-4 rounded-r h-full flex">
            <div
              class="auth-box-panel rounded-border rounded-3xl p-6 w-full h-full flex flex-col items-center justify-center"
            >
              <div
                class="auth-box-inside-panel rounded-border rounded-3xl p-6 w-full h-full flex flex-col items-center justify-center"
              >
                <i class="{{ icon() }} text-primary mb-6 auth-panel-icon"></i>
                <h3 class="m-0 mb-2 text-white">{{ title() }}</h3>
                <p class="m-0 text-white">{{ subtitle() }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
